function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { isBrowser } from "./ssr-utils";
var returnValues = [
    'HY_SUCCESS',
    'HY_NO_HANDLER',
    'HY_PARAM_ERR',
    'HY_UNKNOWN_ERR',
    'HY_NO_PERMISSION',
    'HY_TIMEOUT',
    'HY_FAILED',
    'HY_CLOSED'
];
function isString(obj) {
    return typeof obj === 'string';
}
export var nativeCall = function(api, params, success, failure, timeout) {
    api = api.split('.');
    var className = api[0], methodName = api[1];
    isBrowser() && window.WindVane && window.WindVane.call(className, methodName, params, success, failure, timeout);
};
export var wrapSuccess = function(callback, preprocessor) {
    return (callback || preprocessor) && function(result) {
        result = preprocessor && preprocessor(result) || result;
        callback && callback(wrapResult(result));
    };
};
export var wrapFailure = function(callback) {
    return callback && function(error) {
        callback(wrapError(error));
    };
};
export var wrapResult = function(result) {
    if ((typeof result === "undefined" ? "undefined" : _type_of(result)) === 'object') {
        result.errorCode = 0;
        result.errorMessage = '';
    }
    return result;
};
export var wrapError = function(error) {
    var code = 6;
    var msg = isString(error) ? error : error.ret;
    if (error) {
        var index = returnValues.indexOf(msg);
        code = index > 0 ? index : code;
    }
    return {
        errorCode: code,
        errorMessage: msg,
        data: error
    };
};
